var map = {
	"./ali_pay.png": 59525,
	"./appa.png": 8283,
	"./ca.png": 51351,
	"./chunghwa_pay.png": 43693,
	"./credit_card_pay.png": 25252,
	"./default_pay.png": 86052,
	"./esun_pay.png": 13023,
	"./fet_pay.png": 86908,
	"./gash_pay.png": 91034,
	"./google_pay.png": 55834,
	"./gt_pay.png": 59236,
	"./kiwi.png": 48763,
	"./linepay.png": 78921,
	"./my_card.png": 93419,
	"./myfone_pay.png": 39248,
	"./paypal_pay.png": 7743,
	"./sonet_pay.png": 70155,
	"./union_pay.png": 34663,
	"./visa_pay.png": 13135,
	"./wechat_pay.png": 17487,
	"./xsolla_pay.png": 38886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42638;